import { isSupabaseConfigured } from './supabaseClient';
import { loadConfig } from './configService';
import { getLang } from '../i18n';

/**
 * Anonymous visitor analytics → `analytics_events` (RLS: anon INSERT only;
 * reads are staff-only, surfaced in the Dashboard Analytics card).
 *
 * Fire-and-forget by design: analytics must NEVER break or slow navigation —
 * failures are swallowed, inserts use Prefer: return=minimal (a plain
 * pgInsert would fail here: representation-SELECT is blocked for anon).
 */

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

/** Random per-page-load id — groups a visit's events without identifying anyone. */
const sessionId = Math.random().toString(36).slice(2, 10);

export type AnalyticsEvent =
  | 'session_localized'
  | 'route_start'
  | 'route_arrived'
  | 'tour_start'
  | 'tour_complete'
  | 'media_impression'
  | 'explore_on'
  | 'parking_saved'
  | 'appt_arrived';

export function track(event: AnalyticsEvent, poiId?: string): void {
  if (!isSupabaseConfigured()) return;
  try {
    void fetch(`${SUPABASE_URL}/rest/v1/analytics_events`, {
      method: 'POST',
      headers: {
        apikey: SUPABASE_ANON_KEY!,
        Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
        'Content-Type': 'application/json',
        Prefer: 'return=minimal',
      },
      body: JSON.stringify({
        map_code: loadConfig().code || null,
        event,
        poi_id: poiId ?? null,
        lang: getLang(),
        session_id: sessionId,
      }),
      keepalive: true, // survives page navigations
    }).catch(() => undefined);
  } catch {
    /* never let analytics throw */
  }
}
